/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createRole } from '../fn/administration-role/create-role';
import { CreateRole$Params } from '../fn/administration-role/create-role';
import { deleteRole } from '../fn/administration-role/delete-role';
import { DeleteRole$Params } from '../fn/administration-role/delete-role';
import { exportRoles } from '../fn/administration-role/export-roles';
import { ExportRoles$Params } from '../fn/administration-role/export-roles';
import { getRole } from '../fn/administration-role/get-role';
import { GetRole$Params } from '../fn/administration-role/get-role';
import { importRoles } from '../fn/administration-role/import-roles';
import { ImportRoles$Params } from '../fn/administration-role/import-roles';
import { Role } from '../models/role';
import { RolePagedList } from '../models/role-paged-list';
import { searchRoleList$Any } from '../fn/administration-role/search-role-list-any';
import { SearchRoleList$Any$Params } from '../fn/administration-role/search-role-list-any';
import { searchRoleList$Json } from '../fn/administration-role/search-role-list-json';
import { SearchRoleList$Json$Params } from '../fn/administration-role/search-role-list-json';
import { updateRole } from '../fn/administration-role/update-role';
import { UpdateRole$Params } from '../fn/administration-role/update-role';


/**
 * All about the administration role features
 */
@Injectable({ providedIn: 'root' })
export class AdministrationRoleService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchRoleList()` */
  static readonly SearchRoleListPath = '/administration/roles/search';

  /**
   * Retrieve a role list.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchRoleList$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchRoleList$Json$Response(params?: SearchRoleList$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<RolePagedList>> {
    return searchRoleList$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a role list.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchRoleList$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchRoleList$Json(params?: SearchRoleList$Json$Params, context?: HttpContext): Observable<RolePagedList> {
    return this.searchRoleList$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<RolePagedList>): RolePagedList => r.body)
    );
  }

  /**
   * Retrieve a role list.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchRoleList$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchRoleList$Any$Response(params?: SearchRoleList$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<RolePagedList>> {
    return searchRoleList$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a role list.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchRoleList$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchRoleList$Any(params?: SearchRoleList$Any$Params, context?: HttpContext): Observable<RolePagedList> {
    return this.searchRoleList$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<RolePagedList>): RolePagedList => r.body)
    );
  }

  /** Path part for operation `createRole()` */
  static readonly CreateRolePath = '/administration/roles';

  /**
   * Create a role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createRole()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRole$Response(params: CreateRole$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createRole(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createRole$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRole(params: CreateRole$Params, context?: HttpContext): Observable<void> {
    return this.createRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getRole()` */
  static readonly GetRolePath = '/administration/roles/{uid}';

  /**
   * Retrieve a specific role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRole()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRole$Response(params: GetRole$Params, context?: HttpContext): Observable<StrictHttpResponse<Role>> {
    return getRole(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a specific role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRole(params: GetRole$Params, context?: HttpContext): Observable<Role> {
    return this.getRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<Role>): Role => r.body)
    );
  }

  /** Path part for operation `updateRole()` */
  static readonly UpdateRolePath = '/administration/roles/{uid}';

  /**
   * Update a role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRole()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRole$Response(params: UpdateRole$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateRole(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateRole$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRole(params: UpdateRole$Params, context?: HttpContext): Observable<void> {
    return this.updateRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteRole()` */
  static readonly DeleteRolePath = '/administration/roles/{uid}';

  /**
   * Delete a role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteRole()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRole$Response(params: DeleteRole$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteRole(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteRole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRole(params: DeleteRole$Params, context?: HttpContext): Observable<void> {
    return this.deleteRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportRoles()` */
  static readonly ExportRolesPath = '/administration/roles/export';

  /**
   * Export Roles.
   *
   * Allows to export all the roles as an XLSX File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportRoles$Response(params?: ExportRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportRoles(this.http, this.rootUrl, params, context);
  }

  /**
   * Export Roles.
   *
   * Allows to export all the roles as an XLSX File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportRoles(params?: ExportRoles$Params, context?: HttpContext): Observable<Blob> {
    return this.exportRoles$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `importRoles()` */
  static readonly ImportRolesPath = '/administration/roles/import';

  /**
   * Import the roles.
   *
   * Allows to import the roles, via a XLS File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importRoles()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importRoles$Response(params?: ImportRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importRoles(this.http, this.rootUrl, params, context);
  }

  /**
   * Import the roles.
   *
   * Allows to import the roles, via a XLS File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importRoles$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importRoles(params?: ImportRoles$Params, context?: HttpContext): Observable<void> {
    return this.importRoles$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
